import type { SvgComponent } from '@/types/SvgComponent';

export const LinkBreakIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path
        d="M17.2153 13.1482L17.5676 12.7966L18.2721 12.0932L19.6812 10.6865C20.5137 9.84025 20.9782 8.69931 20.9733 7.51219C20.9685 6.32508 20.4948 5.18796 19.6554 4.34854C18.8159 3.50911 17.6788 3.03539 16.4917 3.03055C15.3046 3.02572 14.1637 3.49017 13.3174 4.32273L11.9084 5.72898L11.2038 6.4321L10.8516 6.78367"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1485 17.216L12.7968 17.5683L12.0934 18.2728L10.6867 19.6819C9.84049 20.5145 8.69955 20.9789 7.51244 20.9741C6.32532 20.9692 5.18821 20.4955 4.34878 19.6561C3.50936 18.8167 3.03563 17.6796 3.0308 16.4924C3.02597 15.3053 3.49041 14.1644 4.32297 13.3182L5.72922 11.9091L6.43235 11.2046L6.78391 10.8523"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.5 4.5L19.5 19.5"
        stroke="currentColor"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
